module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/04-d12748db961e152332570c50ea8b7ea4.jpg";